export var pause = function (t) {
    if (t === void 0) { t = 100; }
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, t); });
};
//# sourceMappingURL=pause.js.map